<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
	<Search :bool='true' />
	<ListWork />
    <HelloWorld />
	<Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import ListWork from "@/components/ListWork.vue";
import Search from "@/components/Search.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
	Search,
	ListWork,
    HelloWorld,
	Footer
  },
};
</script>
<style lang="scss">
	.home{
		height: 100%;
		
	}
</style>
